import { message } from "antd";
import { axiosGet, axiosPost } from "../axios";

export const getAds = async (pageNumber, pageSize, filter) => {
  try {
    const uId = localStorage.getItem("userId")
    const res = await axiosGet({
      path: `advertisement/list?pageNumber=${pageNumber}&itemPerPage=${pageSize}&userId=${uId}${
        filter ? `&filter=${filter}` : ""
      }`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};

export const addAds = async (payload) => {
  try {
    const uId = localStorage.getItem("userId")

    const res = await axiosPost({
      path: `advertisement?userId=${uId}`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const adsPayment = async (payload) => {
  try {
    const res = await axiosPost({
      path: `advertisement/payment`,
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const adsTypes = async () => {
  try {
    const res = await axiosGet({
      path: `advertisement/advertisement-type-list`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
export const offerTypes = async () => {
  try {
    const res = await axiosGet({
      path: `advertisement/offer-type-list`,
    });
    return res;
  } catch (error) {
    message.error(error?.response?.data?.message);
  }
};
